import { navigation } from '@exploration/cms-constants';

export const getDefaultData = () => ({
  callToAction: {
    [navigation.footer_links.footer_column_1_link_1]: {
      href: 'https://local.thrivent.com/',
      text: 'Find Financial Advisors',
    },
    [navigation.footer_links.footer_column_1_link_2]: {
      href: 'https://www.thrivent.com/about-us/support',
      text: 'Contact us',
    },
    [navigation.footer_links.footer_column_1_link_3]: {
      href: 'https://servicing.apps.thrivent.com/',
      text: 'Log in',
    },
    [navigation.footer_links.footer_column_1_link_4]: {
      href: 'https://www.thrivent.com/mobile-app',
      text: 'Mobile App',
    },

    [navigation.footer_links.footer_column_2_link_1]: {
      href: 'https://www.thrivent.com/product-overview',
      text: 'Products & Services',
    },
    [navigation.footer_links.footer_column_2_link_2]: {
      href: 'https://www.thrivent.com/working-with-a-financial-advisor',
      text: 'Working with a financial advisor',
    },
    [navigation.footer_links.footer_column_2_link_3]: {
      href: 'https://www.thrivent.com/why-thrivent',
      text: 'Why Thrivent',
    },
    [navigation.footer_links.footer_column_2_link_4]: {
      href: 'https://www.thrivent.com/client-resources',
      text: 'Resources',
    },

    [navigation.footer_links.footer_column_3_link_1]: {
      href: 'https://www.thrivent.com/governance#financial-info',
      text: 'Financial information',
    },
    [navigation.footer_links.footer_column_3_link_2]: {
      href: 'https://www.thrivent.com/about-us/our-leadership',
      text: 'Leadership',
    },
    [navigation.footer_links.footer_column_3_link_3]: {
      href: 'https://newsroom.thrivent.com/',
      text: 'Newsroom',
    },
    [navigation.footer_links.footer_column_3_link_4]: {
      href: 'https://careers.thrivent.com/',
      text: 'Careers',
    },
    [navigation.footer_links.footer_column_3_link_5]: {
      href: 'https://careers.thrivent.com/become-a-financial-advisor/',
      text: 'Become an advisor',
    },

    [navigation.footer_links.footer_column_4_link_1]: {
      href: 'https://www.thriventchurchloans.com/',
      text: 'Thrivent Church Loans',
    },
    [navigation.footer_links.footer_column_4_link_2]: {
      href: 'https://www.newmanlongtermcare.com/',
      text: 'Newman Long Term Care',
    },
    [navigation.footer_links.footer_column_4_link_3]: {
      href: 'https://www.thriventinsuranceagency.com/',
      text: 'Thrivent Insurance Agency',
    },
    [navigation.footer_links.footer_column_4_link_4]: {
      href: 'https://thriventprivateinvestments.com/',
      text: 'Private Investments',
    },

    [navigation.footer_links.footer_resource_link_1]: {
      href: 'https://www.thrivent.com/forms',
      text: 'Forms',
    },
    [navigation.footer_links.footer_resource_link_2]: {
      href: 'https://www.thrivent.com/tax-resource-center',
      text: 'Tax Resource Center',
    },
    [navigation.footer_links.footer_resource_link_3]: {
      href: 'https://www.thrivent.com/governance',
      text: 'Governance',
    },
    [navigation.footer_links.footer_resource_link_4]: {
      href: 'https://www.thrivent.com/privacy-and-security',
      text: 'PRIVACY & SECURITY',
    },
    [navigation.footer_links.footer_resource_link_5]: {
      href: 'https://www.thrivent.com/privacy-and-security/terms-of-use',
      text: 'Terms of Use',
    },

    [navigation.footer_links.footer_social_link_1]: {
      href: 'https://www.facebook.com/thrivent',
      text: '',
    },
    [navigation.footer_links.footer_social_link_2]: {
      href: 'https://www.linkedin.com/company/6233',
      text: '',
    },
    [navigation.footer_links.footer_social_link_3]: {
      href: 'https://twitter.com/thrivent',
      text: '',
    },
    [navigation.footer_links.footer_social_link_4]: {
      href: 'https://www.instagram.com/thrivent/',
      text: '',
    },
    [navigation.footer_links.footer_social_link_5]: {
      href: 'https://www.youtube.com/channel/UC4EahwEqkPQJIekP8qLebjQ',
      text: '',
    },
  },
  image: {},
  list: {
    disclosures: [
      {
        key: 'disclosures-1',
        text: '©2025 Thrivent. All rights reserved.',
      },
      {
        key: 'disclosures-2',
        text: 'Thrivent is the marketing name for Thrivent Financial for Lutherans. Insurance products issued by Thrivent. Not available in all states. Securities and investment advisory services offered through Thrivent Investment Management Inc., a registered investment adviser, member <a href="https://www.finra.org/">FINRA</a> and <a href="https://www.sipc.org/">SIPC</a>, and a subsidiary of Thrivent. Licensed agent/producer of Thrivent. Registered representative of Thrivent Investment Management, Inc. <a href="https://www.thrivent.com/privacy-and-security/disclosures">Thrivent.com/disclosures.</a>',
      },
      {
        key: 'disclosures-3',
        text: 'Insurance products, securities and investment advisory services are provided by appropriately appointed and licensed financial advisors and professionals. Only individuals who are financial advisors are credentialed to provide investment advisory services. Visit <a href="https://www.thrivent.com/">Thrivent.com</a> or <a href="https://brokercheck.finra.org/">FINRA’s BrokerCheck</a> for more information about our financial advisors.',
      },
    ],
  },
  text: {
    [navigation.footer_links.footer_top_title]: 'Where Money Means More',
    [navigation.footer_links.footer_column_1_title]: 'Connect',
    [navigation.footer_links.footer_column_2_title]: 'Learn',
    [navigation.footer_links.footer_column_3_title]: 'Quick Links',
    [navigation.footer_links.footer_column_4_title]: 'Related Sites',
    [navigation.footer_links.brokerCheckText]:
      'Check the background of our professionals on <a href="https://brokercheck.finra.org/">FINRA’s BrokerCheck</a>.',
  },
  video: {},
});
